import { render, staticRenderFns } from "./CompanyStatusTag.vue?vue&type=template&id=2d87eee6&scoped=true&"
import script from "./CompanyStatusTag.vue?vue&type=script&lang=ts&"
export * from "./CompanyStatusTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d87eee6",
  null
  
)

export default component.exports